/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Provider_ForgejoInputs */



/**
* | output |
* | --- |
* | "Forgejo" |
*
* @param {Spaces_Provider_ForgejoInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_provider_forgejo = /** @type {((inputs?: Spaces_Provider_ForgejoInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Provider_ForgejoInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Forgejo")
	return /** @type {LocalizedString} */ ("Forgejo")
});